/*
 * @Author: zjw
 * @Date: 2021-06-10 15:49:36
 * @LastEditTime: 2022-11-16 16:25:52
 * @FilePath: \web-app\src\network\other\collection.js
 * @Environment: Vue + Element
 * @Description: 收藏管理
 */
import {
    request,
} from '../request.js'

// 收藏列表
export function collectionList(data) {
    return request({
        url: '/web/back/sys/userCollection/list',
        method: 'post',
        data
    })
}

// 删除
export function delCollection(data) {
    return request({
        url: '/web/back/sys/userCollection/delete' + "?id=" + data,
        method: 'delete',
    })
}

// 批量删除
export function allDelCollection(data) {
    return request({
        url: '/web/back/sys/userCollection/batch/delete',
        method: 'delete',
        data
    })
}
